module.exports = __webpack_public_path__ + "static/media/social8.b2bf8d1f.png";